
const COR_CAMADA_ESTADO = 'white'

export default class LayerStyle {
  static get ESTADO () {
    return {
      color: COR_CAMADA_ESTADO,
      weight: 1,
      fill: true,
      fillColor: 'transparent'
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/layerStyles.js